import React, { Component } from "react"
import PropTypes from "prop-types"

import { stateRegions, localRegions, usRegions } from "shared/imports/regionConstants"

import { federalMapConfig } from "search-new/components/Visualization/VisualizationWrappers/MapConfigs"

import { DatePickerStartFilter, DatePickerEndFilter, RegionFilter } from "shared/search/containers/Filter/Filters"

import {
    BarPieDisplay,
    LineDisplay,
    MapDisplay,
    WordCloudDisplay,
} from "search-new/containers/Visualization/VisualizationDisplay/VisualizationDisplays"

const genericVisualizationScene = (props) => {
    const VisualizationDisplay = props.visualizationDisplay

    return <VisualizationDisplay {...props} />
}
genericVisualizationScene.propTypes = {
    visualizationDisplay: PropTypes.func.isRequired,
}

export default genericVisualizationScene

export const genericBarPieScene = (props) =>
    genericVisualizationScene({
        ...props,
        visualizationDisplay: BarPieDisplay,
        visualizationFilterIds: [props.filterId],
        getFilterValues: (filters) => filters.get(props.filterId),
        formatValuesForFilters: (filterValue) => ({
            [props.filterId]: filterValue,
        }),
    })

export const genericLineScene = (props) =>
    genericVisualizationScene({
        ...props,
        visualizationDisplay: LineDisplay,
        visualizationFilterIds: [props.dateStartId, props.dateEndId],
        getFilterValues: (filters) => ({
            start: filters.get(props.dateStartId),
            end: filters.get(props.dateEndId),
        }),
        formatValuesForFilters: ({ dateStart, dateEnd }) => ({
            [props.dateStartId]: dateStart,
            [props.dateEndId]: dateEnd,
        }),
    })

export const genericMapScene = (props) =>
    genericVisualizationScene({
        ...props,
        visualizationDisplay: MapDisplay,
        visualizationFilterIds: [props.filterId],
        getFilterValues: (filters) => filters.get(props.filterId),
        formatValuesForFilters: (regionValue) => ({
            [props.filterId]: regionValue,
        }),
        exclusiveRegions: props.regions,
    })

/* *****************************************************************
 * REUSABLE SCENES
 ******************************************************************* */

export class WordCloudScene extends Component {
    static defaultProps = {
        visualizationDisplay: WordCloudDisplay,
        uniqueVizSceneId: "wordCloud",
        label: "Word Cloud",
        icon: "fa-cloud",
    }

    render() {
        return genericVisualizationScene(this.props)
    }
}

export const createUSMapScene = (configs = {}) => {
    const MapScene = (props) => genericMapScene(Object.assign({}, props, configs))

    MapScene.defaultProps = {
        uniqueVizSceneId: "usMapScene",
        filterId: configs.uniqueFilterId || RegionFilter?.defaultProps?.uniqueFilterId,
        label: "Map",
        icon: "fa-globe",
        configs: configs.configs || federalMapConfig,
        regions: configs.regions || usRegions,
    }

    return MapScene
}

export const USMapScene = createUSMapScene()
export const USMapNoFederalScene = createUSMapScene({ regions: stateRegions.concat(localRegions) })

export class TrendsScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "trendsScene",
        dateStartId: DatePickerStartFilter.defaultProps.uniqueFilterId,
        dateEndId: DatePickerEndFilter.defaultProps.uniqueFilterId,
        label: "Trends",
        icon: "fa-line-chart",
    }

    render() {
        return genericLineScene(this.props)
    }
}
